import { render, staticRenderFns } from "./AddDirectlyHandler.vue?vue&type=template&id=2533c5fa&scoped=true"
import script from "./AddDirectlyHandler.vue?vue&type=script&lang=js"
export * from "./AddDirectlyHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533c5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2533c5fa')) {
      api.createRecord('2533c5fa', component.options)
    } else {
      api.reload('2533c5fa', component.options)
    }
    module.hot.accept("./AddDirectlyHandler.vue?vue&type=template&id=2533c5fa&scoped=true", function () {
      api.rerender('2533c5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddDirectlyHandler.vue"
export default component.exports